import { render, staticRenderFns } from "./Receptions.vue?vue&type=template&id=5945f69e&scoped=true&"
import script from "./Receptions.vue?vue&type=script&lang=js&"
export * from "./Receptions.vue?vue&type=script&lang=js&"
import style0 from "./Receptions.vue?vue&type=style&index=0&id=5945f69e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5945f69e",
  null
  
)

export default component.exports